import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ جلب حسابات الأدمن
export const getAdminAccounts = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      "/admin/get-admin-accounts",
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching admin accounts:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// ✅ جلب حسابات المستخدمين
export const getClientsAccounts = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params, // احتياطي للـ pagination أو الفلترة
  };

  try {
    const response = await api.get(
      "/admin/get-user-accounts",
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching user accounts:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// ✅ إنشاء حساب جديد (Admin / User)
export const createNewAccount = async (data = {}, params = {}) => {
  if (!data || typeof data !== "object") {
    throw new Error("Account data is required.");
  }

  const {
    name,
    email,
    password,
    role,
    type,
  } = data;

  // validations بسيطة
  if (!name) throw new Error("name is required");
  if (!email) throw new Error("email is required");
  if (!password) throw new Error("password is required");
  if (!role) throw new Error("role is required");
  if (!type) throw new Error("type is required");

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  const payload = {
    name,
    email,
    password,
    role,
    type,
  };

  try {
    const response = await api.post(
      "/admin/create-new-account",
      payload,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating new account:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// ✅ تحديث حساب (Admin / User)
export const updateAccount = async (accountId, data = {}, params = {}) => {
  if (!accountId) throw new Error("accountId is required.");
  if (!data || typeof data !== "object") throw new Error("data is required.");

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  // ✅ ابعت فقط الحقول اللي اتبعتت (علشان التعديل يكون اختياري)
  const payload = {};
  if (data.name != null) payload.name = String(data.name);
  if (data.email != null) payload.email = String(data.email);
  if (data.password != null && String(data.password).trim() !== "") payload.password = String(data.password);
  if (data.role != null) payload.role = String(data.role);   // admin | user ...
  if (data.type != null) payload.type = String(data.type);   // admin | user ...
  if (data.status != null) payload.status = Number(data.status); // 1 | 0

  try {
    const response = await api.post(
      `/admin/update-account/${accountId}`,
      payload,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating account:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];

      if (serverData.message) msgs.push(serverData.message);
      if (serverData.error) msgs.push(serverData.error);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
